const initUserCentrics = () => {
  document.querySelectorAll('[data-user-centrics-link-to-settings]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      (window as any).UC_UI?.showSecondLayer?.();
    });
  });

  document.querySelectorAll<HTMLElement>('[data-hide-from-consentmanager]').forEach(trigger => {
    let attempts = 0;
    const maxAttempts = 40; // wait for 40×100ms = 4s maximum

    const interval = setInterval(() => {
        if ((window as any).UC_UI instanceof Object && (window as any).UC_UI.isInitialized() === true) {
          (window as any).UC_UI.closeCMP();
          clearInterval(interval); // Stop polling once it’s available
        } else if (++attempts >= maxAttempts) {
          clearInterval(interval); // Stop after max attempts
        }
      },
      100);
  });
};

if (document.readyState !== "loading") {
  initUserCentrics();
} else {
  document.addEventListener("DOMContentLoaded", initUserCentrics);
}
